import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import DataTable from "react-data-table-component";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { apiAxios } from "../../../../utils/apiAxios";

export default function GenerateCoupon() {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [couponCode, setCouponCode] = useState("");
  const [amount, setAmount] = useState("");
  const [coupons, setCoupons] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
   const [percentage, setPercentage] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const columns = [
    {
      name: "Coupon Code",
      selector: (row: any) => row.couponCode,
      sortable: true,
    },
    {
      name: "Expiry Date",
      selector: (row: any) => formatDate(row.expiryDate),
      sortable: true,
      center: true,
    },
     {
    name: "Percentage (%)", 
    selector: (row: any) => `${row.percentage}%`, 
    sortable: true,
    center: true,
  },
  ];


const fetchCoupons = async () => {
  try {
    const response = await apiAxios.get(
      `${API_BASE_URL}/coupon/GetAll`,
      {
        headers: {
          AuthorizationData: token,
        },
      }
    );

    if (response.data?.isSuccess) {
      setCoupons(response.data.singleData || []);
    } else {
      toast.error(response.data?.status || "Failed to fetch coupons");
    }
  } catch (error) {
    console.error("Error fetching coupons:", error);
    toast.error("Something went wrong while fetching coupons");
  }
};

  useEffect(() => {
    fetchCoupons();
  }, []);
  const token = sessionStorage.getItem("token") || "";


const handleGenerate = async () => {
  const trimmedCode = couponCode.trim();

  if (!trimmedCode || !percentage || !startDate) {
    toast.error("All fields are required");
    return;
  }

  // if (trimmedCode.length !== 10) {
  //   toast.error("Coupon code must be exactly 10 characters");
  //   return;
  // }


  const percentageValue = Number(percentage);
  if (percentageValue < 0 || percentageValue > 100) {
    toast.error("Percentage must be between 0 and 100");
    return;
  }
  setLoading(true);

  const payload = { couponCode: trimmedCode, percentage: percentageValue,
    expiryDate: startDate.toISOString(),
  };

  try {
    const response = await apiAxios.post(
      `${API_BASE_URL}/coupon/create`,
      payload,
      {
        headers: {
          AuthorizationData: token,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data?.isSuccess === true) {
      toast.success(response.data.status || "Coupon created successfully");
      fetchCoupons();
      handleClear();
    } else {
      toast.error(response.data?.status || "Failed to create coupon");
    }

  } catch (error: any) {
    console.error("Error creating coupon:", error);
    toast.error("Something went wrong while generating coupon");
  } finally {
    setLoading(false);
  }
};





  const handleClear = () => {
    setCouponCode("");
    // setAmount("");
    setPercentage("");
    setStartDate(null);
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };


const isCouponValid =
  //couponCode.trim().length === 10 &&
  // amount &&
    percentage &&
  Number(percentage) >= 0 &&
  Number(percentage) <= 100 &&
  startDate;
  return (
    <div className="Container">
      <h4 className="mb-4 ">Generate Coupon</h4>
 <div className="premium-card mt-3 ">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">Coupon Code</label>
            {/* <input
              type="text"
              className="form-control"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
            /> */}
            <input
              type="text"
              className="form-control"
              value={couponCode}
             
              onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
            />

          </div>

          <div className="col-md-4 position-relative">
            <label className="form-label">Expiry Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date: Date | null) => setStartDate(date)}
             
              className="form-control"
              portalId="root-datepicker"
              dateFormat="dd-MM-yyyy"
               minDate={new Date()}
            />
            <i
              className="bi bi-calendar3"
              style={{
                position: "absolute",
                right: "25px",
                top: "73%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "#6c757d",
              }}
            ></i>
          </div>
      

          <div className="col-md-4">
            <label className="form-label">Percentage (%)</label>
            <input
              type="number"
              className="form-control"
              value={percentage}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
                  setPercentage(value);
                }
              }} min="0" max="100" step="0.01" placeholder="0-100" />
            {percentage && (Number(percentage) < 0 || Number(percentage) > 100) && (
              <small className="text-danger">Percentage must be between 0-100</small>
            )}
          </div>


        </div>
        <div className="row">
          <div className="col-md-12 d-flex gap-1 mt-1">
            {/* <button
              type="button"
              className="btn btn-primary updatebtncustom"
              onClick={handleGenerate}
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate"}
            </button> */}

            <button
              type="button"
              className="btn btn-primary updatebtncustom"
              onClick={handleGenerate}
              disabled={!isCouponValid || loading}
            >
              {loading ? "Generating..." : "Generate"}
            </button>

            <button type="button" className="btn  btn-secondary user-login-history-btnclear "
            onClick={handleClear} >
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
     <div className="premium-card mt-4 ">
             <h5 className="mb-3">Coupon List</h5>
        <div className="row">
          <div className="col-md-12">
            <DataTable
              columns={columns}
              data={coupons}
              pagination
              highlightOnHover
              striped
              persistTableHead
              noDataComponent="No coupons available"
                className="admin-delivery-table"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
